module.exports = __webpack_public_path__ + "img/wuliu.5464f05a.png";